export function scrollToMissingField(isSmooth: boolean = false, parentClass: string = '') {
  // it could happen that class doesn't appear immediately
  setTimeout(() => {
    const selector = (parentClass)
      ? `.${parentClass} .form-field__error`
      : '.form-field__error';
    const firstErrorField = document.querySelector(selector);
    if (firstErrorField) {
      firstErrorField.scrollIntoView({ block: 'center', behavior: isSmooth ? 'smooth' : 'auto' });
    } else {
      window.scrollTo(0, 0);
    }
  }, 200);
}

export function autoscrollToRequired(isSmooth: boolean = false) {
  const firstErrorField = document.querySelector('[data-scrollto="true"]');
  if (firstErrorField) {
    firstErrorField.scrollIntoView({ block: 'center', behavior: isSmooth ? 'smooth' : 'auto' });
  } else {
    window.scrollTo(0, 0);
  }
}
